module.exports = fox._r("images/events/newyear/snow2.png", __webpack_public_path__ + "images/events/newyear/snow2.png");


//////////////////
// WEBPACK FOOTER
// ./images/events/newyear/snow2.png
// module id = 571
// module chunks = 2